import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import {
  INFO_PANE_PAGES,
  openPatientPane,
  openProgramPane,
} from '../../../../../../redux_store';
import cx from 'classnames';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { compare } from 'fast-json-patch';

const useStyles = makeStyles((theme) => ({
  hasLink: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 12px',
    marginLeft: -12,
    borderRadius: 10,
    background: 'transparent',
    transition: '.3s',
    // width: 'min-content',
    color: theme.palette.primary.main,
    maxWidth: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    '&:hover': {
      transition: '.3s', color: '#0073b0',
    },
  },
  infoIcon: {
    width: 16, marginLeft: 4, color: '#868686',
  },
}));

const InfoPaneWrapper = memo(({ infoPanePage, currentValue, row }) => {
  const dispatch = useDispatch();
  const { en: { infoPane } } = useSelector((state) => state.i18n);
  const classes = useStyles();

  const onClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    const newData = {
      accountUUID: row?.accountUUID,
      patientUUID: row?.patientUUID ?? row?.uuid,
      patientFirstName: row?.patientFirstName ?? row?.firstName,
      patientLastName: row?.patientLastName ?? row?.lastName,
      value: currentValue,
    };
    if (infoPanePage === INFO_PANE_PAGES.patient_page) {
      dispatch(openPatientPane(newData));
    }
    if (infoPanePage === INFO_PANE_PAGES.program) {
      dispatch(openProgramPane(newData));
    }
  }, []);

  return <div
    onClick={onClick}
    className={cx(classes.hasLink, 'activeCellLink')}
  >
    <div style={{
      maxWidth: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    }}>
      {currentValue}
    </div>
    {<InfoOutlinedIcon className={classes.infoIcon} />}
  </div>;
}, areEqual);

function areEqual(prevProps, nextProps) {
  return !compare({ currentValue: prevProps.currentValue }, { currentValue: nextProps.currentValue }).length;
}

export default InfoPaneWrapper;
